import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuButton from './MenuButton';
import ListButton from './ListButton';

const useStyles = makeStyles({
	buttonRound: {
		borderRadius: '16px',
	},
});
const fields = {
	KodYeudMichraz: {
		'1': 'בנייה נמוכה/צמודת קרקע',
		'2': 'בנייה רוויה',
		'3': 'מסחר ו/או משרדים',
		'4': 'תעשיה',
		'5': 'מוסדות ו/או בניינים ציבוריים',
		'8': 'מלונאות',
		'12': 'מגורים ו/או מסחר ו/או מלונאות ו/או נופש',
		'10': 'כרייה וחציבה',
		'13': 'דיור מוגן (בית אבות)',
		'16': 'עודפים',
		'20': 'דיור להשכרה',
		'99': 'אחר',
	},
	KodSugMichraz: {
		'1': 'מכרז פומבי רגיל',
		'2': 'הרשמה והגרלה',
		'3': 'מכרז למגרש בלתי מסוים',
		'5': 'מחיר מטרה',
		'6': 'דיור להשכרה',
		'8': 'דיור במחיר מופחת',
		'9': 'מכרז ייזום',
		'10': 'מכרזי עמידר',
	},
	StatusMichraz: {
		'1': 'פתוח',
		'2': 'נדון בועדת המכרזים',
		'3': 'בוטל',
	},
};
export default function SearchAppBar() {
	const classes = useStyles();
	const matches = useMediaQuery('(min-width:600px)');
	const checkboxSelectionCB = (selection: string[]) => {
		console.log(selection);
	};
	return (
		<div>
			{matches && (
				<Grid
					container
					spacing={1}
					direction="row"
					justifyContent="flex-start"
					alignItems="flex-start"
					alignContent="stretch"
					wrap="wrap"
				>
					<Grid item md={4}>
						<Box
							mt={1}
							mb={1}
							ml={1}
							sx={{ flexDirection: 'row', display: 'flex' }}
						>
							{/* <Stack spacing={1} direction="row"> */}
							<ListButton
								label="סוג מכרז"
								options={Object.entries(fields.KodSugMichraz)}
								cb={(selection: string[]) => checkboxSelectionCB(selection)}
							/>
							<ListButton
								label="יעוד"
								options={Object.entries(fields.KodYeudMichraz)}
								cb={(selection: string[]) => checkboxSelectionCB(selection)}
							/>
							<ListButton
								label="סטטוס מכרז"
								options={Object.entries(fields.StatusMichraz)}
								cb={(selection: string[]) => checkboxSelectionCB(selection)}
							/>
							{/* </Stack> */}
						</Box>
					</Grid>

					{/* <Grid item md={4}>
						<Box mt={1} mb={1} ml={1}>
							<Stack spacing={1} direction="row">
								<Button
									size="small"
									variant="outlined"
									className={classes.buttonRound}
								>
									מכרזים פתוחים
								</Button>
								<MenuButton />
								

								<Button
									size="small"
									variant="outlined"
									className={classes.buttonRound}
								>
									מכרזים סגורים
								</Button>
							</Stack>
						</Box>
					</Grid>
					<Grid item md={8}>
						<Box mt={1} mb={1}>
							<Stack spacing={1} direction="row">
								<Button
									size="small"
									variant="outlined"
									className={classes.buttonRound}
								>
									בנייה רוויה
								</Button>
								<Button
									size="small"
									variant="outlined"
									className={classes.buttonRound}
								>
									בנייה נמוכה
								</Button>
								<Button
									size="small"
									variant="outlined"
									className={classes.buttonRound}
								>
									דיור מוגן
								</Button>
								<Button
									size="small"
									variant="outlined"
									className={classes.buttonRound}
								>
									תעסוקה
								</Button>
								<Button
									size="small"
									variant="outlined"
									className={classes.buttonRound}
								>
									אחר
								</Button>
							</Stack>
						</Box>
					</Grid> */}
				</Grid>
			)}
		</div>
	);
}
